
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import FormikActions from "../../../../commons/formik/FormikActions";
import FormikCheckbox from "../../../../commons/formik/FormikCheckbox";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import { StyledResolucion } from "../../../../styled/Prevencion";

const InformarExamenesForm = ({ handleSubmit, initialValues, handleClose, open, examenesMedicos }) => {
  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        Informar Exámenes
      </DialogTitle>

      {
        examenesMedicos.length === 0 ?
          (
            <DialogContent >
              <CircularLoading />
            </DialogContent>
          )
          :
          (
            <Formik
              initialValues={initialValues}
              onSubmit={(values) => handleSubmit(values)}
              enableReinitialize
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <DialogContent>
                    <Grid container>
                      <StyledResolucion.DialogGridItem item xs={12}>
                        {
                          examenesMedicos.map((examen) => {
                            return (
                              <div key={examen.id.toString()}>
                                <FormikCheckbox
                                  key={examen.id.toString()}
                                  name={`${examen.id}.value`}
                                  label={examen.nombre}
                                />
                              </div>
                            )
                          })
                        }

                      </StyledResolucion.DialogGridItem>
                    </Grid>
                  </DialogContent>

                  <DialogActions>
                    <FormikActions handleCancel={handleClose} />
                  </DialogActions>
                </Form>
              )}
            </Formik>
          )
      }


    </Dialog>
  );



}

export default InformarExamenesForm